import { ImageParams } from 'components/Common/ResponsiveImage'
import { ImageChangeHandler, ImageLoadHandler } from 'LuxKit/Carousel/BaseImageCarousel'
import React, { PropsWithChildren, ReactElement, useCallback, useContext } from 'react'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import OfferListEventsContext, { OfferListEvents } from 'components/OfferList/OfferListEventsContext'
import SearchImageCarouselWrapper from './SearchImageCarouselWrapper'

const imageParams: ImageParams = {
  quality: 'best',
  fit: 'center',
  mobileWidth: '578px',
  tabletWidth: '670px',
  desktopWidth: '410px',
  dpr: 2,
}

interface Props extends PropsWithChildren {
  bookmarkAction?: ReactElement
  images: Array<App.Image>
  productLabel?: ReactElement | false
  onImageChange?: ImageChangeHandler
  onImageLoad?: ImageLoadHandler
}

function _SearchTileHero({
  bookmarkAction,
  images,
  productLabel,
  onImageChange,
  onImageLoad,
}: Props) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const dispatchOfferListEvent = useContext(OfferListEventsContext)

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const handleImageLoaded = useCallback<ImageLoadHandler>((index, image) => {
    dispatchOfferListEvent({ type: OfferListEvents.offerReady })
    onImageLoad?.(index, image)
  }, [dispatchOfferListEvent, onImageLoad])

  return <SearchImageCarouselWrapper
    productLabel={productLabel}
    bookmarkAction={bookmarkAction ? <TripGuard>{bookmarkAction}</TripGuard> : undefined}
    images={images}
    imageParams={imageParams}
    onImageChange={onImageChange}
    onImageLoad={handleImageLoaded}
  />
}

export default _SearchTileHero
